/**
 * Production-safe logger utility
 * Only logs to console in development, silent in production
 * Reduces Vercel Log Drains costs by eliminating unnecessary logs
 */

type LogLevel = 'log' | 'info' | 'warn' | 'error' | 'debug';

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * Log only in development
 */
export const devLog = (...args: any[]) => {
  if (isDevelopment) {
    console.log(...args);
  }
};

/**
 * Info level - only in development
 */
export const devInfo = (...args: any[]) => {
  if (isDevelopment) {
    console.info(...args);
  }
};

/**
 * Warning - only in development
 */
export const devWarn = (...args: any[]) => {
  if (isDevelopment) {
    console.warn(...args);
  }
};

/**
 * Debug - only in development
 */
export const devDebug = (...args: any[]) => {
  if (isDevelopment) {
    console.debug(...args);
  }
};

/**
 * Error - ALWAYS logs (even in production)
 * Use for actual errors that need to be tracked
 */
export const logError = (...args: any[]) => {
  console.error(...args);
};

/**
 * Critical production logs - ALWAYS logs
 * Use sparingly for important production events
 * Examples: payment processed, user signup, critical errors
 */
export const prodLog = (...args: any[]) => {
  console.log(...args);
};
